import { createFileRoute } from '@tanstack/react-router'
import { useStore } from '@tanstack/react-store'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { SectionNavGrid } from '@/components/shared/section-nav-grid'
import { usePermissions } from '@/hooks/use-permissions'
import { getVisibleSettingsNavItems } from '@/lib/settings-nav'
import { organizationStore } from '@/stores/organization.store'

export const Route = createFileRoute('/_app/settings')({
  component: SettingsIndexPage,
})

function SettingsIndexPage() {
  useBreadcrumbFromRoute()
  const selectedOrganizationId = useStore(organizationStore, (s) => s.selectedOrganizationId)
  const { can } = usePermissions(selectedOrganizationId || '')

  // Same definition and same gating the sidebar's Settings group uses, so a
  // card never advertises a page the user would be denied at.
  const navItems = getVisibleSettingsNavItems({ can })

  return (
    <SectionNavGrid
      title="Settings"
      description="Manage your organization and system settings."
      items={navItems}
    />
  )
}
